module.exports = __webpack_public_path__ + "img/ico_video_play.b5e72abd.png";